import { IModule } from '../../../__core/Interfaces/IModule';
import { IStudentResult } from '../../../__core/Interfaces/IStudentResult';
import { IChapterResults } from '../../../__core/Interfaces/IChapterResults';

export const getPercentFromPoints = (
  score: number,
  maxScore: number
): number => {
  return Math.round((score * 100) / maxScore);
};

export const getResultsForChapter = (
  chapterId: string,
  module: IModule,
  modulesResults: IStudentResult
): IChapterResults | undefined => {
  let results: IChapterResults | undefined = undefined;

  if (module && modulesResults) {
    modulesResults.moduleResults.forEach((moduleResult) => {
      moduleResult.chapterResults.forEach((chapterResult) => {
        if (chapterResult.chapterId === chapterId) {
          results = chapterResult;
          return;
        }
      });
    });
  }

  return results;
};
